import { useEffect, useState } from 'react';
import FormDatePicker from '@views/components/Inputs/FormDatePicker';
import { Col, Form, Row } from 'antd';

import { ReactComponent as SearchIcon } from '@/assets/icons/zoom-input.svg';
import SvgConverter from '@/views/components/Common/SvgConverter';
import FormInput from '@/views/components/Inputs/FormInput';
import FormSelectBox from '@/views/components/Inputs/FormSelectBox';
import SecondaryLabel from '@/views/components/Labels/SecondaryLabel';
import Paper from '@/views/components/Paper/Paper';
import DestinationDetailsGrid from '@/views/screens/Savers/DestinationDetailsGrid';
import OriginDetailsGrid from '@/views/screens/Savers/OriginDetailsGrid';
import TrailerSelectionModal from '@/views/screens/Savers/TrailerSelectionModal';

import useDropdownState from './hooks/useDropdownState';

const TrailerManagement = ({
  formTrailerRequestManagement,
  userType,
  initialValues,
  editMode,
  isMultiple,
  handleValuesChange,
  label,
  activeTabName,
  companyId,
  onFormSubmit,
  status,
  setTrailerId,
  setLoadId,
  checkOptions,
  handleOptionToggle,
  handleUserStatus,
  requestUserType,
  setDeliveryFormValues,
  setPickupFormValues,
}) => {
  const dropdownState = useDropdownState(companyId);
  const [selectTrailerModal, setSelectTrailerModal] = useState(false);
  const trailerToggle = () => {
    setSelectTrailerModal(!selectTrailerModal);
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO: Fix this
  useEffect(() => {
    handleUserStatus(label);
  }, [label]);

  const trailerNumberFlag = label === 'Pickup Empty' || label === 'Pickup Loaded';

  return (
    <div className={`${isMultiple ? '' : 'pt-15'}`}>
      <Row gutter={20}>
        <Col sm={24}>
          <span className="pull-right color-1" style={{ marginTop: '-26px', position: 'fixed', right: '32px' }}>
            <strong> {userType} </strong> Logged In
          </span>
        </Col>
      </Row>
      <Form
        style={{ maxHeight: '600px', overflowX: 'auto' }}
        initialValues={initialValues}
        form={formTrailerRequestManagement}
        onValuesChange={handleValuesChange}
      >
        <Paper className="mb-5">
          <div className="card-header">
            <span> </span>
          </div>
          <div className="card-body">
            <Row gutter={15} className="mb-5">
              <Col sm={24}>
                <div className="color-1 pb-10 text-center">
                  <strong className="f-20"> {label} </strong>
                </div>
              </Col>
              <Col flex={1}>
                <Row gutter={15}>
                  <Col sm={5}>
                    <FormInput
                      label="Trailer#"
                      editMode={editMode}
                      name="selTrailer"
                      margin="m-0"
                      placeholder="Select Trailer"
                      suffix={
                        <SvgConverter
                          className="cursor-pointer"
                          disabled={trailerNumberFlag}
                          onClick={() => !trailerNumberFlag && trailerToggle()}
                          Icon={SearchIcon}
                        />
                      }
                      readOnly
                    />
                  </Col>
                </Row>
              </Col>
            </Row>

            <hr />

            <Row gutter={15} className="mb-5">
              <Col sm={14}>
                <Row gutter={15}>
                  <Col sm={6}>
                    <FormSelectBox
                      label="Trailer / Unit Size"
                      editMode={editMode}
                      name="UnitSize"
                      margin="m-0"
                      options={dropdownState.unitSizeOptions}
                      loading={dropdownState.loading.unitSize}
                      placeholder="Select Unit Size"
                      disabled
                    />
                  </Col>

                  <Col sm={6}>
                    <FormInput
                      label="Inventory move justification"
                      editMode={editMode}
                      margin="m-0"
                      placeholder="User Entry"
                      name="txtinvJusti"
                    />
                  </Col>
                  {label !== 'Pickup Empty' && (
                    <Col sm={6}>
                      <FormSelectBox
                        label="Commodity - Product"
                        editMode={editMode}
                        name="Commodity"
                        margin="m-0"
                        options={dropdownState.commodityOptions}
                        loading={dropdownState.loading.commodities}
                        placeholder="Select Commodity"
                        labelInValue
                      />
                    </Col>
                  )}

                  <Col sm={6}>
                    <FormSelectBox
                      label="Rental Company"
                      editMode={editMode}
                      name="PickupRentalCompany"
                      margin="m-0"
                      placeholder="Select Rental Company"
                      options={dropdownState.rentalCompanyOptions}
                      loading={dropdownState.loading.rentalCompany}
                    />
                  </Col>
                </Row>

                <Row gutter={15}>
                  <Col sm={6}>
                    <FormDatePicker label="Entry Date" name="entryDate" margin="m-0" />
                  </Col>
                </Row>
              </Col>
              <Col sm={9} offset={1}>
                <Row gutter={15} className="mt-5">
                  <Col sm={10}>
                    <Row gutter={15}>
                      <Col sm={10}>
                        <SecondaryLabel className="f-12"> Roll Door?: </SecondaryLabel>
                      </Col>
                      <Col sm={14}>
                        <Row gutter={15}>
                          <Col>
                            {/** biome-ignore lint/correctness/useUniqueElementIds: TODO: Fix this */}
                            <input
                              className="form-check-input"
                              type="radio"
                              id="rollDoorYes"
                              onChange={(e) => handleOptionToggle(e)}
                              checked={checkOptions.rollDoor}
                              name="rollDoor"
                              value="yes"
                              disabled
                            />

                            <label className="f-12" htmlFor="rollDoorYes">
                              Yes
                            </label>
                          </Col>

                          <Col>
                            {/** biome-ignore lint/correctness/useUniqueElementIds: TODO: Fix this */}
                            <input
                              className="form-check-input"
                              type="radio"
                              name="rollDoor"
                              id="rollDoorNo"
                              value="no"
                              onChange={(e) => handleOptionToggle(e)}
                              checked={!checkOptions.rollDoor}
                              disabled
                            />

                            <label className="f-12" htmlFor="rollDoorNo">
                              No
                            </label>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                  <Col sm={14}>
                    <Row gutter={15}>
                      <Col sm={12}>
                        <SecondaryLabel className="f-12"> Direct from partner?: </SecondaryLabel>
                      </Col>
                      <Col sm={12}>
                        <Row gutter={15}>
                          <Col>
                            {/** biome-ignore lint/correctness/useUniqueElementIds: <explanation> */}
                            <input
                              className="form-check-input"
                              type="radio"
                              name="directFromPartner"
                              value="yes"
                              id="directFromPartnerYes"
                              onChange={(e) => handleOptionToggle(e)}
                              checked={checkOptions.directFromPartner}
                              disabled
                            />

                            <label className="f-12" htmlFor="directFromPartnerYes">
                              Yes
                            </label>
                          </Col>

                          <Col>
                            {/** biome-ignore lint/correctness/useUniqueElementIds: <explanation> */}
                            <input
                              className="form-check-input"
                              type="radio"
                              name="directFromPartner"
                              value="no"
                              id="directFromPartnerNo"
                              onChange={(e) => handleOptionToggle(e)}
                              checked={!checkOptions.directFromPartner}
                              disabled
                            />

                            <label className="f-12" htmlFor="directFromPartnerNo">
                              No
                            </label>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row gutter={16}>
              <OriginDetailsGrid
                formTrailerRequestManagement={formTrailerRequestManagement}
                editMode={editMode}
                dropdownState={dropdownState}
                requestUserType={requestUserType}
                activeTabName={label}
                setDeliveryFormValues={setDeliveryFormValues}
                setPickupFormValues={setPickupFormValues}
                isMultiple={isMultiple}
              />
            </Row>
            <Row gutter={16}>
              <DestinationDetailsGrid
                formTrailerRequestManagement={formTrailerRequestManagement}
                editMode={editMode}
                dropdownState={dropdownState}
                requestUserType={requestUserType}
                activeTabName={label}
                setDeliveryFormValues={setDeliveryFormValues}
                setPickupFormValues={setPickupFormValues}
                isMultiple={isMultiple}
              />
            </Row>
          </div>
          <div className="mt-2 text-center pb-10">
            <button type="button" className="btn btn-dipblue cursor-pointer" onClick={onFormSubmit}>
              {activeTabName === 'Pickup' && isMultiple ? 'Next' : 'Carrier Selection'}
            </button>
          </div>
        </Paper>
        <TrailerSelectionModal
          formTrailerRequestManagement={formTrailerRequestManagement}
          setTrailerId={setTrailerId}
          setLoadId={setLoadId}
          findTrailerToggle={trailerToggle}
          status={status}
          label={label}
          selectTrailerModal={selectTrailerModal}
        />
      </Form>
    </div>
  );
};

export default TrailerManagement;
